<template>
    <nav class="breadcrumb-outer" aria-label="breadcrumb">
        <div class="breadcrumb-container">
            <a
                @click="doAction"
                class="btn btn-sm btn-back"
                aria-label="Powrót"
            >
                <div class="a-icon">
                    <svg
                        width="7"
                        height="12"
                        viewBox="0 0 7 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M2.561 5.625L6.061 10 4.5 11.25 0 5.624 4.5 0l1.562 1.25-3.5 4.375z"
                            fill="currentColor"
                        />
                    </svg>
                </div>
                <span class="text-md">{{ text }}</span>
            </a>
        </div>
    </nav>
</template>

<script>
export default {
    props: {
        text: {
            type: String,
            default: 'Wróć'
        },
        defaultUrl: {
            type: String,
            required: false
        },
        forceDefaultUrl: {
            type: Boolean,
            required: false
        },
        stop: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        doAction() {
            if (this.stop) {
                return
            }

            if (
                this.forceDefaultUrl ||
                (this.defaultUrl && this.$router.count === 0)
            ) {
                this.$router.push({ name: this.defaultUrl })
            } else {
                this.$router.go(-1)
            }
        }
    }
}
</script>
